export default __webpack_public_path__ + "static/media/View_1UP_Icon.29815a0e.svg";